<template>
  <div>
    <div class="buttonRow">
        <el-button
          type="primary"
          @click="$router.push(`submission`)"
        >
          Add a new film
        </el-button>
        <el-button
          type="primary"
          @click="$router.push(`series-license`)"
        >
          Add a new series
        </el-button>
    </div>
    <DashboardRow ref="dashboardGroup0" :videos="needInfoVideos" title="Need more info"/>
    <DashboardRow ref="dashboardGroup1" :videos="pendingVideos" title="Incomplete" :hasAddButton="true"/>
    <DashboardRow ref="dashboardGroup3" :videos="activeVideos" title="Under Review" :hasPendingWarning="true"/>
    <DashboardRow ref="dashboardGroup4" :videos="inactiveVideos" title="Reviewed"/>
  </div>
</template>

<script>
import NOTIFY_CONSTANTS from '@/config/notify-constants';
import SUBMISSION_STATUS from '@/assets/data/viddsee/submissionStatus';
import eventBus from '@/libs/eventBus';
import DashboardRow from './ListRow';


export default {
  name: 'Dashboard',
  components: {
    DashboardRow,
  },
  computed: {
    videos() {
      return this.$store.getters['submission/list'];
    },
    needInfoVideos() {
      return [
        ...this.videos[SUBMISSION_STATUS.TYPE.moreinfo] || [],
      ];
    },
    pendingVideos() {
      return [
        ...this.videos[SUBMISSION_STATUS.TYPE.incomplete] || [],
      ];
    },
    activeVideos() {
      return [
        ...this.videos[SUBMISSION_STATUS.TYPE.fasttrack] || [],
        ...this.videos[SUBMISSION_STATUS.TYPE.pending] || [],
      ];
    },
    inactiveVideos() {
      return [
        ...this.videos[SUBMISSION_STATUS.TYPE.approved] || [],
        ...this.videos[SUBMISSION_STATUS.TYPE.rejected] || [],
      ];
    },
  },
  methods: {
    scrollToGroup(index) {
      const group = this.$refs[`dashboardGroup${index}`];
      if (group) {
        group.$el.scrollIntoView();
      }
    },
  },
  mounted() {
    this.$store.dispatch('submission/list')
      .catch((error) => {
        this.$notify.error({
          title: error.message,
          message: 'There is an error listing your submissions. Please contact us if the problem persist',
          duration: NOTIFY_CONSTANTS.DURATION.FOREVER,
        });
        throw error;
      });
    eventBus.$on('dashboard/scrollToGroup', this.scrollToGroup);
  },
};
</script>

<style scoped>
.dashboard {
  display: flex;
  flex-wrap: wrap;
}
.buttonRow {
  margin-top: 1em;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ListWrapper.vue